
import { OptionsClass } from "@/domain/entities/MainApp";
import { Options, prop, Vue } from "vue-class-component";
import Multiselect from "@/app/ui/components/multiselect-search-tag/index.vue";
import {
  optionBillingSchedule,
  optionRangeTimePayment
} from "@/app/infrastructures/misc/Constants";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import SelectPhoneCountry from "@/app/ui/views/shipment/booking/component/select-phone-country.vue";

export type BillingInformationSectionProp = {
  noWhatsApp: string;
  noWhatsAppDialCode?: string;
  billingSchedule: OptionsClass;
  timeRangePayment: OptionsClass;
  email: string[];
};

export type BillingInformationSectionErrorProp = {
  contactWhatsApp: boolean;
  emailBilling: boolean;
};

class Props {
  modelValue = prop<BillingInformationSectionProp>({
    default: {
      billingSchedule: new OptionsClass(),
      email: [],
      noWhatsApp: "",
      noWhatsAppDialCode: "",
      timeRangePayment: new OptionsClass()
    },
    required: true,
    type: Object
  });
  error = prop<BillingInformationSectionErrorProp>({
    default: {
      contactWhatsApp: false,
      emailBilling: false
    },
    required: true,
    type: Object
  });
  isMY = prop<boolean>({
    default: false
  });
}

@Options({
  components: {
    Multiselect,
    SelectPhoneCountry
  }
})
class BillingInformationSection extends Vue.with(Props) {
  //billing schedule
  billingScheduleList = optionBillingSchedule;

  //range time payment
  rangeTimePaymentList = optionRangeTimePayment;

  emailOptions = [];

  get prefix() {
    return this.isMY ? "+60" : "+62";
  }

  get formModel() {
    return this.modelValue;
  }

  set formModel(val) {
    this.$emit("update:modelValue", { ...val });
  }

  get formErrorModel() {
    return this.error;
  }

  set formErrorModel(val) {
    this.$emit("update:error", { ...val });
  }

  get errorEmail() {
    const res = this.formModel.email?.map((key: any) => {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(key.name);
    });
    this.formErrorModel.emailBilling = res?.includes(false);
    return this.formModel.email?.length && this.formErrorModel.emailBilling;
  }

  get defaultDialCode() {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.countryCode;
    return getPhoneDisplayCode(countryCode);
  }

  get errorWhatsApp() {
    return {
      error: this.formErrorModel.contactWhatsApp,
      errorPhone: false,
      errorMandatory: false,
      errorPhoneCode: false,
      phoneCharMinimal: false,
      message: ""
    };
  }

  onSetWhatsApp(v: string) {
    this.$emit("update:modelValue", { ...this.modelValue, noWhatsApp: v });
    this.validatePhone(v);
  }

  onSetWhatsAppDialCode(v: string) {
    this.$emit("update:modelValue", { ...this.modelValue, noWhatsAppDialCode: v });
  }

  mounted() {
    if (!this.modelValue.noWhatsAppDialCode) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        noWhatsAppDialCode: this.defaultDialCode
      });
    }
  }

  validatePhone(value: string) {
    if (this.isMY) {
      this.formErrorModel.contactWhatsApp =
        !/^\d+$/.test(value);
    } else {
      this.formErrorModel.contactWhatsApp =
        !/^\d+$/.test(value) || value.length < 8;
    }
  }

  formatNumber(value: string) {
    const newValue = value.replace(/^62|^60|^0|[\D]+/g, "");
    return newValue.startsWith("0")
      ? newValue.slice(1, newValue.length)
      : newValue;
  }
}

export default BillingInformationSection;
